
import { Box, Container, Grid2, Paper, Typography } from '@mui/material'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import "./googlePage.css"


const GooglePage = () => {

    const navigate = useNavigate();
    const googleReview = () => {
        window.location.href = "https://search.google.com/local/writereview?placeid=ChIJ2955AeYs34cRHGWoRTF4ED0";
    }

    return (
        <div id='re-google'>
            <div className='g-card' onClick={() => googleReview()}>
                <h4>
                    Post Your Review
                </h4>
                <p className='content'>We'd really appreciate if you would take a moment to post your review on Google.</p>

                <div className='g-btn'>
                    <img src='https://www.pngmart.com/files/16/official-Google-Logo-PNG-Image.png'
                        alt='google logo' className='google-icon'

                    />
                    <p className='g-par'>Post on Google</p>
                    <ArrowForwardIosIcon className='g-arrow' />
                </div>
            </div>

        </div>
    )
}

export default GooglePage